import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { OrderMenuMobile } from "../POSMobile/OrderMenuMobile";

export const TableOnClick = ({
  isOpen,
  toggle,
  selectedTable,
  setSelectedTable,
  tables,
  setTables,
  setTotalOrder,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <select
          className="selectEle"
          value={
            selectedTable?.identification ? JSON.stringify(selectedTable) : "" // Show default when not selected
          }
          onChange={(e) => setSelectedTable(JSON.parse(e.target.value))}
        >
          <option value="" disabled>
            Select a Table
          </option>

          {tables?.map((e, index) => {
            const isSelected =
              selectedTable?.identification === e.identification;

            return (
              <option
                key={index}
                value={JSON.stringify(e)}
                style={{
                  backgroundColor: isSelected ? "#e0f7fa" : "white",
                  fontWeight: isSelected ? "bold" : "normal",
                }}
              >
                {e.identification}
              </option>
            );
          })}
        </select>
       
      </ModalHeader>

      <ModalBody>
        <OrderMenuMobile
          selectedTable={selectedTable}
          setSelectedTable={setSelectedTable}
          setTotalOrder={setTotalOrder}
        />
      </ModalBody>
    </Modal>
  );
};
